import React from "react";
import { RESOLVE_LOCAL_USER_STATE } from "../auth/AuthActions";

export default function PostSignUp() {
  const user = RESOLVE_LOCAL_USER_STATE();

  return (
    <div className="container signup-custom">
      <br /><br />
      <h1>Activate your account!</h1>
      <hr />
      <br /><br />
      <p>
        A confirmation email has been sent to <strong>{user.email}</strong>.
      </p>
      <p>Please check your email and activate your account!</p>
    </div>
  );
}
